/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let Shape3DRectangle = class Shape3DRectangle extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createRectangle(shape.sizeX, shape.sizeY);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            sizeX: s.x * source.sizeX,
            sizeY: s.y * source.sizeY,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DRectangle = tslib_1.__decorate([
    Shape('Shape3D.Rectangle'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DRectangle);
export { Shape3DRectangle };
//# sourceMappingURL=Shape3DRectangle.js.map